import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Api from "../../admin/components/api/Api";
import Notification, { showToast } from "../../components/common/notification/Notification";
import "./ProfileForm.css";

const ProfileForm = () => {
  const [states,          setStates]          = useState([]);
  const [selectedState,   setSelectedState]   = useState(null);
  const [cities,          setCities]          = useState([]);
  const [isCityDisabled,  setIsCityDisabled]  = useState(true);
  const [services,        setServices]        = useState([]);
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.auth.user);
  const userId   = loggedInUser?.user?.id;
  const userType = loggedInUser?.user?.userType?.name;

  const [profile, setProfile] = useState({ id: userId });

  const editDetailsApi = Api({ url: `admin/editUser` });
  const stateApi       = Api({ url: `admin/states/${1}` });
  const cityApi        = Api({ url: `admin/cities/${selectedState?.value}` });
  const serviceApi     = Api({ url: `all/services` });

  useEffect(() => {
    fetchStates();
    fetchCities();
    fetchServices();
  }, [selectedState]);

  const fetchServices = async () => {
    try {
      const responseData = await serviceApi.fetchDataBySingleId();
      setServices(responseData.data.services);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const fetchStates = async () => {
    try {
      const response = await stateApi.fetchData();
      if (response.data.statusType === "SUCCESS") {
        setStates(response.data.states);
        setIsCityDisabled(false);
      }
    } catch {
      setIsCityDisabled(true);
    }
  };

  const fetchCities = async () => {
    if (!isCityDisabled) {
      try {
        const response = await cityApi.fetchData();
        if (response.data.statusType === "SUCCESS") {
          setCities(response.data.cities);
        }
      } catch {
        setCities([]);
      }
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await editDetailsApi.editData(profile);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("Profile updated successfully", { type: "success" });
        navigate("/dashboard/myspace", { replace: true });
      }
    } catch {
      showToast("Something went wrong", { type: "error" });
    }
  };

  return (
    <div className="pf">
      <Notification />

      <div className="pf__card">
        <h2 className="pf__title">Complete Your Profile</h2>
        <p className="pf__subtitle">Add your details or skip to continue</p>

        <form onSubmit={handleProfileSubmit} className="pf__form">

          <div className="pf__row">
            <div>
              <label className="pf__field-label">First Name</label>
              <input
                className="pf__input"
                type="text"
                placeholder="Enter first name"
                value={profile.first_name || ""}
                onChange={(e) => setProfile({ ...profile, first_name: e.target.value })}
              />
            </div>
            <div>
              <label className="pf__field-label">Last Name</label>
              <input
                className="pf__input"
                type="text"
                placeholder="Enter last name"
                value={profile.last_name || ""}
                onChange={(e) => setProfile({ ...profile, last_name: e.target.value })}
              />
            </div>
          </div>

          <div>
            <label className="pf__field-label">Email</label>
            <input
              className="pf__input"
              type="email"
              placeholder="Enter email"
              value={profile.email_address || ""}
              onChange={(e) => setProfile({ ...profile, email_address: e.target.value })}
            />
          </div>

          <div className="pf__row">
            <div>
              <label className="pf__field-label">State</label>
              <select
                className="pf__select"
                value={profile.state || ""}
                onChange={(e) => {
                  const selectedOption = e.target.selectedOptions[0];
                  setSelectedState(selectedOption);
                }}
              >
                <option value="">Select state</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>{state.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="pf__field-label">City</label>
              <select
                className="pf__select"
                value={profile.city || ""}
                disabled={isCityDisabled}
                onChange={(e) => setProfile({ ...profile, city_id: e.target.value })}
              >
                <option value="">Select city</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>{city.name}</option>
                ))}
              </select>
            </div>
          </div>

          {userType === "PARTNER" && (
            <div>
              <label className="pf__field-label">Service</label>
              <select
                className="pf__select"
                value={profile.service || ""}
                onChange={(e) => setProfile({ ...profile, service_id: e.target.value })}
              >
                <option value="">Select service</option>
                {services.map((service) => (
                  <option key={service.id} value={service.id}>{service.name}</option>
                ))}
              </select>
            </div>
          )}

          <div className="pf__actions">
            <button
              type="button"
              className="pf__btn-skip"
              onClick={() => {
                navigate("/dashboard/myspace", { replace: true });
                window.location.reload();
              }}
            >
              Skip for now
            </button>
            <button type="submit" className="pf__btn-save">
              Save & Continue
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ProfileForm;